import { Directive, Input, OnChanges } from '@angular/core';
import { WorkflowItemDataDirective } from '@app/workflow/directives/workflow-item-data/workflow-item-data.directive';
import { BehaviorSubject, Observable } from 'rxjs';
import { distinctUntilChanged, switchMap } from 'rxjs/operators';

@Directive({
	selector: '[appWorkflowItemKey]',
})
export class WorkflowItemKeyDirective<T = unknown> implements OnChanges {

	@Input('appWorkflowItemKey') key: string;

	private key$ = new BehaviorSubject<string>(undefined);

	constructor(private workflowItemData: WorkflowItemDataDirective) { }

	ngOnChanges(): void {
		this.key$.next(this.key);
	}

	/**
	 * Observable for a property on the current workflow items SessionItemData
	 */
	get property$(): Observable<T> {
		return this.key$.pipe(
			distinctUntilChanged(),
			switchMap(key => this.workflowItemData.property$(key) as Observable<T>),
		);
	}

	/**
	 * Observable for a property on the current workflow items SessionItemData
	 */
	get propertyFull$(): Observable<T> {
		return this.key$.pipe(
			distinctUntilChanged(),
			switchMap(key => this.workflowItemData.propertyFull$(key) as Observable<T>),
		);
	}

	/**
	 * Get a property on the current workflow items SessionItemData
	 */
	getProperty(): T {
		return this.workflowItemData.getProperty(this.key) as T;
	}

	/**
	 * Set a property in the current workflow items SessionItemData
	 * @param value property value
	 */
	setProperty(value: T): void {
		this.workflowItemData.setProperty(this.key, value);
	}
}
